import { useProjectSidebarStore } from "@/zapi-frontend/stores/projectSidebarStore";
import { AppButton, FigmaTypography } from "@libs/zapi-ui/custom";
import { CardHeader } from "@libs/zapi-ui/shadcn";
import { XIcon } from "@phosphor-icons/react";

export function IntelligenceQuestionsHeader() {
  const { closeHandler } = useProjectSidebarStore();

  return (
    <CardHeader className="flex flex-col border border-innoveraZinc-100 rounded-t-[8px] text-zinc-500 text-[14px] py-2 px-4">
      <div className="flex items-center justify-between">
        <FigmaTypography variant="label-2" className="text-zinc-900">
          Intelligence Questions
        </FigmaTypography>

        <AppButton data-testid="intelligence-questions-close-button" appearance="text" size="icon" onClick={closeHandler}>
          <XIcon />
        </AppButton>
      </div>
    </CardHeader>
  );
}
